import React from 'react';
import { MapPin, Briefcase, Plane, Key } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Network = () => {
  const { t } = useLanguage();

  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h1 className="hero-large" style={{ marginBottom: '24px' }}>
            {t.home.networkTitle}
          </h1>
          <p className="body-large" style={{
            color: 'var(--text-secondary)',
            maxWidth: '900px',
            margin: '0 auto',
            lineHeight: 1.8
          }}>
            {t.home.networkSubtitle}
          </p>
        </div>
      </section>

      {/* Network Content Section */}
      <section className="section-padding">
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '48px',
            marginBottom: '64px'
          }}>
            {/* Section 1 */}
            <div>
              <div style={{
                width: '56px',
                height: '56px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '20px',
                border: '1px solid var(--border-light)',
                background: 'var(--bg-secondary)'
              }}>
                <MapPin size={28} color="var(--text-primary)" />
              </div>
              <h3 className="heading-1" style={{ marginBottom: '12px' }}>
                {t.home.networkSection1Title}
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: 1.7 }}>
                {t.home.networkSection1Desc}
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <div style={{
                width: '56px',
                height: '56px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '20px',
                border: '1px solid var(--border-light)',
                background: 'var(--bg-secondary)'
              }}>
                <Briefcase size={28} color="var(--text-primary)" />
              </div>
              <h3 className="heading-1" style={{ marginBottom: '12px' }}>
                {t.home.networkSection2Title}
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: 1.7 }}>
                {t.home.networkSection2Desc}
              </p>
            </div>

            {/* Section 3 */}
            <div>
              <div style={{
                width: '56px',
                height: '56px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '20px',
                border: '1px solid var(--border-light)',
                background: 'var(--bg-secondary)'
              }}>
                <Plane size={28} color="var(--text-primary)" />
              </div>
              <h3 className="heading-1" style={{ marginBottom: '12px' }}>
                {t.home.networkSection3Title}
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: 1.7, marginBottom: '12px' }}>
                {t.home.networkSection3Desc}
              </p>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '8px'
              }}>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                  • {t.home.networkSection3Item1}
                </li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                  • {t.home.networkSection3Item2}
                </li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                  • {t.home.networkSection3Item3}
                </li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                  • {t.home.networkSection3Item4}
                </li>
              </ul>
            </div>

            {/* Section 4 */}
            <div>
              <div style={{
                width: '56px',
                height: '56px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '20px',
                border: '1px solid var(--border-light)',
                background: 'var(--bg-secondary)'
              }}>
                <Key size={28} color="var(--text-primary)" />
              </div>
              <h3 className="heading-1" style={{ marginBottom: '12px' }}>
                {t.home.networkSection4Title}
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: 1.7 }}>
                {t.home.networkSection4Desc}
              </p>
            </div>
          </div>

          {/* CTA Box */}
          <div style={{
            textAlign: 'center',
            padding: '48px',
            background: 'var(--bg-secondary)',
            border: '1px solid var(--border-light)'
          }}>
            <p className="hero-medium" style={{
              color: 'var(--text-primary)',
              lineHeight: 1.8,
              maxWidth: '700px',
              margin: '0 auto',
              fontStyle: 'italic'
            }}>
              {t.home.networkCta}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Network;
